import { render, staticRenderFns } from "./FinalizeCart.vue?vue&type=template&id=1506177e"
import script from "./FinalizeCart.vue?vue&type=script&lang=js"
export * from "./FinalizeCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1506177e')) {
      api.createRecord('1506177e', component.options)
    } else {
      api.reload('1506177e', component.options)
    }
    module.hot.accept("./FinalizeCart.vue?vue&type=template&id=1506177e", function () {
      api.rerender('1506177e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logged/FinalizeCart.vue"
export default component.exports